<template>
    <div class="d-flex flex-column gap-8">
        <IncludedOrderStatesBox :order-states="statistics.order_states"/>

        <div class="row text-center my-10">
            <div class="col-md-4">
                <div class="text-3xl font-weight-lighter">
                    {{ statistics.total_orders }}
                </div>
                <div class="text-xl text-uppercase font-weight-bold">
                    {{ __('orders.orders') }}
                </div>
            </div>
            <div class="col-md-4">
                <div class="text-3xl font-weight-lighter">
                    {{ statistics.articles_sold }}
                </div>
                <div class="text-xl text-uppercase font-weight-bold">
                    {{ __('orders.sold_articles') }}
                </div>
            </div>
            <div class="col-md-4">
                <div class="text-3xl font-weight-lighter">
                    <Price :value="statistics.sales_volume"
                           :currency="statistics.currency"
                    />
                </div>
                <div class="text-xl text-uppercase font-weight-bold">
                    {{ __('orders.sales_volume') }}
                </div>
            </div>
        </div>

        <div class="grid grid-cols-2 gap-4">
            <OrdersBySalesChannel :statistics="statistics"/>

            <OrdersByStore :statistics="statistics"
                           :stores="stores"/>

            <OrdersByType :statistics="statistics"/>

            <OrdersByWeekday :statistics="statistics"/>
        </div>
    </div>
</template>

<script>
import OrderStatisticsLayout from "@layouts/Statistics/OrderStatisticsLayout.vue";
import OrdersByWeekday from "@components/Stats/Widgets/OrdersByWeekday.vue";
import Price from "@components/Price.vue";
import Card from "@components/Cards/Card.vue";
import Store from "@components/Store/Store.vue";
import { Link } from '@inertiajs/vue2';
import IncludedOrderStatesBox from "@components/Stats/IncludedOrderStatesBox.vue";
import OrdersByType from "@components/Stats/Widgets/OrdersByType.vue";
import OrdersByStore from "@components/Stats/Widgets/OrdersByStore.vue";
import OrdersBySalesChannel from "@components/Stats/Widgets/OrdersBySalesChannel.vue";

export default {
    layout: OrderStatisticsLayout,

    components: {
        OrdersBySalesChannel,
        OrdersByStore,
        OrdersByType,
        IncludedOrderStatesBox,
        Store,
        Card,
        Price,
        OrdersByWeekday,
        Link
    },

    props: {
        stores: Object,
        statistics: {
            types: [Object, Array]
        },
    },

    data() {
        return {
            colorCursor: 150
        }
    },
}
</script>
